import React from "react"
import {
  Container,
} from "reactstrap"

const Standard = () => {
  //meta title
  document.title="NattoLabs - Painel Adminitrativo";
  return (
    <React.Fragment>
    <div className="page-content">
      <Container fluid>
        <h4>Standard - Produção de Frango</h4>
      </Container>
    </div>
  </React.Fragment>
  );
}

export default Standard;
